// extracted by mini-css-extract-plugin
export var disabled = "_5-a";
export var hierarchyLinkGray = "_5-4";
export var hierarchyLinkUnderline = "_5-3";
export var hierarchyPrimary = "_5-0";
export var hierarchySecondary = "_5-1";
export var hierarchyTertiary = "_5-2";
export var pressed = "_5-6";
export var themeAction = "_5-5";
export var themeDestructive = "_5-8";
export var themeNormal = "_5-7";
export var themeSuccess = "_5-9";